import React from "react";
import EditTopicForm from "./components/EditTopicForm";

const EditTopicFormContainer = () => {
    return <EditTopicForm/>
}

export default EditTopicFormContainer;